<form 
    (ngSubmit)="$event.preventDefault(); saveSectionN();"
    [formGroup]="sectionNForm"
    class="w-full h-full flex flex-col items-center justify-start gap-4 overflow-y-auto"
>
    <div class="w-full overflow-y-auto px-1">                    
        <h2 class="pb-2 w-full oswald-font text-xl font-medium text-start">
            N. Suicide Assessment
        </h2>
        <div class="w-full flex flex-col items-center gap-4 pb-4">
            <div class="w-full flex flex-col items-start text-start">
                <div class="w-full font-semibold">
                    <p>In some situations, a Suicide Risk Assessment may be warranted in addition to the Behavioral Threat Assessment. Does this situation warrant the completion of a Suicide Risk Assessment in addition to a Threat Assessment? *</p>
                </div>
                <div class="w-full flex items-start gap-2">
                    <div>
                        <input type="radio" id="suicide_risk_assessment_yes" value="{{ this.yesNo.Yes }}" class="hidden peer"
                            formControlName="suicide_risk_assessment"
                        >
                        <label for="suicide_risk_assessment_yes"
                        class="inline-flex items-center justify-center w-full px-2 py-1 text-sm font-medium text-center hover:text-gray-900 bg-gray-50 border rounded cursor-pointer text-gray-500 border-gray-300 peer-checked:border-blue-700 peer-checked:bg-blue-50 peer-checked:text-blue-700 hover:bg-gray-50">
                            Yes
                        </label>
                    </div>
                    <div>
                        <input type="radio" id="suicide_risk_assessment_no" value="{{ this.yesNo.No }}" class="hidden peer"
                            formControlName="suicide_risk_assessment"
                        >
                        <label for="suicide_risk_assessment_no"
                        class="inline-flex items-center justify-center w-full px-2 py-1 text-sm font-medium text-center hover:text-gray-900 bg-gray-50  border rounded cursor-pointer text-gray-500 border-gray-300 peer-checked:border-blue-700 peer-checked:bg-blue-50 peer-checked:text-blue-700 hover:bg-gray-50">
                            No
                        </label>
                    </div>
                </div>
            </div>                       
            <div *ngIf="sectionNForm.get('suicide_risk_assessment')?.value === this.yesNo.Yes" class="w-full flex flex-col items-center text-start">
                <div class="w-full font-semibold">
                    <p>Identify who, on this team, is responsible for ensuring that a Suicide Risk Assessment occurs. Name of person completing the suicide assessment: *</p>
                </div>
                <div class="w-full flex flex-col items-center">
                    <input 
                        type="text"
                        formControlName="suicide_risk_assessment_person"
                        class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded block w-full p-2"
                        placeholder="E.g., John Doe"
                    >
                </div>
            </div>
            <div *ngIf="sectionNForm.get('suicide_risk_assessment')?.value === this.yesNo.Yes" class="w-full flex flex-col items-center text-start">
                <div class="w-full font-semibold">
                    <p>When: *</p>
                </div>
                <div class="w-full flex items-center">
                    <div class="w-full relative">
                        <div class="absolute inset-y-0 start-0 flex items-center ps-3 pointer-events-none">
                            <svg class="w-4 h-4 text-gray-500 dark:text-gray-400" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 20 20">
                                <path d="M20 4a2 2 0 0 0-2-2h-2V1a1 1 0 0 0-2 0v1h-3V1a1 1 0 0 0-2 0v1H6V1a1 1 0 0 0-2 0v1H2a2 2 0 0 0-2 2v2h20V4ZM0 18a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V8H0v10Zm5-8h10a1 1 0 0 1 0 2H5a1 1 0 0 1 0-2Z"/>
                            </svg>
                        </div>
                        <input id="datepicker-when" #datepickerWhen name="suicide_risk_assessment_date" type="text" class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded block w-full ps-10 p-2">
                    </div>
                </div>
            </div>
        </div>
        <div class="w-full flex flex-row gap-2 items-center justify-end">
            <button
                type="submit"
                class="w-20 flex items-center justify-center px-4 py-1.5 rounded-md border bg-gradient-to-b oswald-font text-white"
                [ngClass]="{
                    'border-nside-gray-100 from-nside-gray-100 to-nside-gray-200 cursor-not-allowed': this.sectionNForm.invalid,
                    'border-nside-orange-100 from-nside-orange-300 to-nside-orange-400 hover:bg-gradient-to-b hover:from-nside-orange-100 hover:to-nside-orange-200': this.sectionNForm.valid
                }"
                [disabled]="this.sectionNForm.invalid"
            >
                Save
            </button>
        </div>
    </div>
</form>